export const iconFontAwesomeLogisticsBox = (
	<i className="fa-solid fa-box"></i>
);
